import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';

import ValidationAlert from '../../../app/components/ValidationAlert';
import { CreateUpdateParamsDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import Button from '../../../common/components/Button';

import { ParamsForm } from './ParamsForm';

interface ParamsEditorProps {
  id: string;
  param: CreateUpdateParamsDto;
  handleClose?: () => void;
  show?: boolean;
  onCompleted: (
    param: CreateUpdateParamsDto,
    id: string,
  ) => Promise<{
    saved: boolean;
    errors: string[];
  }>;
  readOnly: boolean;
}

export const ParamsEditor: React.FC<ParamsEditorProps> = props => {
  const [param, setParam] = useState(props.param);
  const [show, setShow] = useState(props.show || false);
  const [showSaveErrors, setShowSaveErrors] = useState(false);
  const [saveErrors, setSaveErrors] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const saveParam = async () => {
    setIsLoading(true);
    props
      .onCompleted(param, props.id)
      .then(saveStatus => {
        if (!saveStatus.saved) {
          setSaveErrors(saveStatus.errors);
          setShowSaveErrors(true);
          return;
        }
        handleClose();
      })
      .catch(errorResponse => {
        console.error(errorResponse);
      })
      .finally(() => setIsLoading(false));
  };

  const createErrors = (errors: string[]) => {
    setSaveErrors(errors);
    setShowSaveErrors(!!errors.length);
  };

  const propertyChange = (obj: Partial<CreateUpdateParamsDto>) => {
    setParam({ ...param, ...obj });
  };

  useEffect(() => {
    if (props.show) {
      setSaveErrors([]);
      setShowSaveErrors(false);
      setParam(props.param);
      setShow(true);
    }
  }, [props.param, props.show]);

  const handleClose = () => {
    setShow(false);
    if (props.handleClose) {
      props.handleClose();
    }
  };

  return (
    <Modal
      onHide={handleClose}
      show={show}
      centered={true}
      keyboard={true}
      backdrop="static"
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Edycja parametrów</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ParamsForm
          id={props.id}
          param={param}
          readOnly={props.readOnly}
          propertyChange={propertyChange}
          createErrors={createErrors}
        />
        <ValidationAlert
          show={showSaveErrors}
          errors={saveErrors}
          className="m-3"
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-secondary"
          onClick={handleClose}
          disabled={isLoading}
        >
          Zamknij
        </Button>
        {!props.readOnly && (
          <Button variant="primary" onClick={saveParam} isLoading={isLoading}>
            Zapisz
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
